export default function Spinner({ size = 'md', className = '', overlay = false, message = '' }) {
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-4',
    lg: 'h-12 w-12 border-4',
    xl: 'h-16 w-16 border-4',
  }

  const spinner = (
    <div
      className={`${sizeClasses[size]} animate-spin rounded-full border-white border-t-brand ${!overlay ? className : ''}`}
      role="status"
      aria-label="Loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  )

  if (overlay) {
    return (
      <div
        className={`fixed inset-0 z-50 flex flex-col items-center justify-center bg-black bg-opacity-50 ${className}`}
        role="dialog"
        aria-modal="true"
        aria-label="Loading overlay"
      >
        {spinner}
        {message && (
          <p className="mt-4 text-white text-lg font-medium">{message}</p>
        )}
      </div>
    )
  }

  return spinner
}